import { environment as ENV } from '@environment';

import {
  EventDataLayer, EventProperties, UserProperties
} from '@avo/interface/trigger-props';
import { UserInfo } from '@app/modules/core/interfaces/user';
import { UserAddresses } from '@app/modules/core/interfaces/address';
import { TriggerAmplitudeEntity } from '@amplitude/interfaces/trigger-entity';
import { isDevelopmentEnvironmentByAmplitude } from '@amplitude/mappers/is-development-amplitude.mapper';

declare const dataLayer;

const ANONYMOUS = 'Anónimo';

export function triggerAmplitudeEventApp(trigger: TriggerAmplitudeEntity): void {
  if (ENV.production || isDevelopmentEnvironmentByAmplitude()) {
    triggerAmplitudeEvent(trigger);
  }
}

export function triggerAmplitudeEventFromAvo(eventData: EventDataLayer): void {
  dataLayerPush(eventData);
}

export function triggerBrazeEventFromAvo(eventType: string, eventProperties: EventProperties): void {
  if (ENV.production || isDevelopmentEnvironmentByAmplitude()) {
    dataLayerPush({
      event: 'triggerBrazeEvent',
      eventType,
      eventProperties
    });
  }
}

function triggerAmplitudeEvent(trigger: TriggerAmplitudeEntity): void {
  dataLayerPush({
    event: 'triggerAmplitudeEvent',
    eventType: trigger.EVENT_NAME,
    eventProperties: {
      ...mapEventProperties(trigger.EVENT_PROPS),
      ...trigger.SEARCH_PROPS,
      ...trigger.PRODUCT_PROPS,
    },
    userProperties: mapUserProperties(trigger.USER, trigger.USER_ADDRESSES)
  });
}

export function setUserId(userId: number): void {
  dataLayerPush({
    event: 'amplitudeSetUserId',
    userId: `${ENV.countryInfo.iso_code}_${userId}`
  });
}

function mapEventProperties(eventProperties: EventProperties): EventProperties {
  const { SUPPORT_LINK, ...store_config } = ENV.store_configuration;
  return {
    ...eventProperties,
    ...store_config,
    MARKET_COUNTRY: ENV.countryInfo.iso_code.toUpperCase(),
  };
}

function mapUserProperties(user: UserInfo, userAddresses: UserAddresses): UserProperties {
  if (!user || !userAddresses) {
    return null;
  }
  const activeAddres = 'addresses' in userAddresses ? userAddresses.addresses.find(data => data.active) : null;

  return {
    USER_ID: user.id ? `${ENV.countryInfo.iso_code}_${user.id}` : ANONYMOUS,
    IS_PRIME: !!user && user.is_prime,
    REWARD_LEVEL: user.loyalty ? user.loyalty.type : null,
    ADDRESS: activeAddres ? activeAddres.address : ANONYMOUS,
    LAT: activeAddres ? activeAddres.lat : ANONYMOUS,
    LNG: activeAddres ? activeAddres.lng : ANONYMOUS,
    MICROZONE_NAME: activeAddres && activeAddres.zone ? activeAddres.zone.name : ANONYMOUS,
    MICROZONE_ID: activeAddres && activeAddres.zone ? activeAddres.zone.id : 0,
    HAS_RAPPICARD: !!user.has_rappicard
  };
}

function dataLayerPush(event: EventDataLayer): void {
  try {
    dataLayer.push(event);
  } catch (err) { }
}
